import React from "react";
import "./CartItem.scss"
import plus from "../../../assets/plus.svg"
import minus from "../../../assets/minus.svg"
import placeholder from "../../../assets/collections/empty.jpg"

const CartItem = ({ item, onDelete, increaseQty, decreaseQty }) => {

    return (
        <div className="CartItem">
            <div className="CartItem-Image">
                <img alt="" src={item.ProductImage ?? placeholder} />
            </div>
            <div className="CartItem-details">
                <div className="CartItem-title">{item.ProductName}</div>
                <div className="CartItem-price"> £{(item.ProductPrice * item.ProductQty).toFixed(2)}</div>
                <div className="item-container">
                    <div className="qty-container">
                        <div className="qty-cont-action " onClick={decreaseQty}><img alt="" src={minus} /></div>
                        <div className="qty-cont-item">{item.ProductQty}</div>
                        <div className="qty-cont-action " onClick={increaseQty}><img alt="" src={plus} /></div>
                    </div>
                    <div className="delete" onClick={onDelete}>Remove</div>
                </div>
            </div>
        </div>
    )
}
export default CartItem